// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { CostReviewType } from '../Enums/CostReviewType';
export class NewCostReviewAttributesBase {
  readonly newCostReviewType: string = "NewCostReviewAttributesBase";
  costReviewType: CostReviewType;
  estimateName: string;
  accountName: string;
  shipToAddress: string;
  sellPrice: number;
  tdc: number;
  gm: number;
  proposalLink: string;
  opportunityLink: string;
}
